import React from 'react';
import { UseFormRegister, FieldErrors } from 'react-hook-form';
import { PettyCash } from '../../../types';
import Input from '../Input';

interface PettyCashFinancialSummaryProps {
  register: UseFormRegister<PettyCash>;
  errors: FieldErrors<PettyCash>;
}

const PettyCashFinancialSummary: React.FC<PettyCashFinancialSummaryProps> = ({ register, errors }) => {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="text-lg font-semibold text-gray-900">Financial Summary - الملخص المالي</h3>
      </div>
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div>
            <Input
              label="Previous Balance - رصيد من اليوم السابق"
              type="number"
              step="0.01"
              {...register('previousBalance', { 
                required: 'Previous balance is required',
                min: { value: 0, message: 'Previous balance cannot be negative' }
              })}
              error={errors.previousBalance?.message}
            />
          </div>
          <div>
            <Input
              label="Total Received - إجمالي مستلم اليوم"
              type="number"
              step="0.01"
              {...register('totalReceived', { 
                required: 'Total received is required',
                min: { value: 0, message: 'Total received cannot be negative' }
              })}
              error={errors.totalReceived?.message}
            />
          </div>
          <div>
            <Input
              label="Total Expenses - المجموع مصروف اليوم"
              type="number"
              step="0.01"
              {...register('totalExpenses')}
              disabled
              className="bg-gray-50"
            />
          </div>
          <div>
            <Input
              label="Final Balance - رصيد آخر اليوم"
              type="number"
              step="0.01"
              {...register('finalBalance')}
              disabled
              className="bg-gray-50 font-semibold"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PettyCashFinancialSummary;
